
import { mapGetters } from 'vuex'

import ArticleCard from '@article/components/Card'

export default {
  components: {
    ArticleCard,
  },

  computed: {
    ...mapGetters({
      buyingGuide: 'landing/buyingGuide',
    }),
  },
}
